import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import ColumnButton from "src/components/Page/GridButtons/ColumnButton";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import {
  deleteTestimonialSaga,
  getTestimonialDetailsSaga,
  getTestimonialListSaga,
} from "src/store/testimonials/saga";
import {
  TestimonialDetailDto,
  TestimonialDto,
} from "src/store/testimonials/type";
import TestimonialCreateForm from "./create";
import TestimonialEditForm from "./edit";
const TestimonialPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [data, setData] = useState<TestimonialDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<TestimonialDetailDto>();
  const columns = [
    {
      text: t("Testimonial.NameSurname"),
      dataField: "NameSurname",
    },
    {
      text: t("Testimonial.Message"),
      dataField: "Message",
      formatter: (cellContent: any) => cellContent.slice(0, 40) + "...",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Testimonial.PageTitle")}
        metaTag={t("Testimonial.MetaTag")}
        gridProps={{
          addTitle: t("Testimonial.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getTestimonialListSaga,
          onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getTestimonialDetailsSaga({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          deleteButton: {
            text: (id, data: TestimonialDto) =>
              t("Testimonial.DeleteQA", {
                name: data.NameSurname,
              }),
            action: deleteTestimonialSaga,
            onClick: (id, data) => setShowEdit(data),
          },
        }}
      />
      <TestimonialCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getTestimonialListSaga,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <TestimonialEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getTestimonialListSaga,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default TestimonialPage;
